export const BARCODE_TYPES = {
  EAN: 'barcode_ean',
  UPC: 'barcode_upc',
};
